import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from './auth';

const STRAPI_URL = import.meta.env.VITE_STRAPI_URL ?? 'http://localhost:1337';

const normalizeErrorMessage = (error, fallback) => {
	return (
		error?.response?.data?.error?.message ||
		error?.response?.data?.message ||
		error?.message ||
		fallback
	);
};

export const useSupplierPortalInsightsStore = defineStore('supplierPortalInsights', {
	state: () => ({
		generatedAt: null,
		suppliers: [],
		loading: false,
		error: null,
	}),

	actions: {
		authHeaders() {
			const authStore = useAuthStore();
			return authStore.token ? authStore.requestHeaders.headers : {};
		},

		resetError() {
			this.error = null;
		},

		async fetchOverview() {
			try {
				this.loading = true;
				this.error = null;
				const response = await axios.get(`${STRAPI_URL}/api/supplier-portal/admin/overview`, {
					headers: this.authHeaders(),
				});
				const data = response?.data || {};
				this.generatedAt = data.generatedAt || null;
				this.suppliers = Array.isArray(data.suppliers) ? data.suppliers : [];
				return data;
			} catch (error) {
				this.error = normalizeErrorMessage(error, 'Failed to load supplier access');
				throw error;
			} finally {
				this.loading = false;
			}
		},
	},
});
